import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button, Label,
    Fieldset, Legend
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import Shimmer from "react-shimmer-effect";
import { FileInput, generateFormData } from '../../../../helpers/ui/FileInput'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import Select from "react-select"

import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../../services/apiResponse'

import { accessRole } from "../../../../helpers/access_role"
import CustomSelect from '../../../../helpers/ui/CustomSelect';
import moment from 'moment';
import DetailBloc from './Blocs/DetailBloc';

class IndexView extends Component {

    detailBloc = new DetailBloc();
    
    queryParams = new URLSearchParams(window.location.search)

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            birthNational: ""
        }
    }

    dateParse = (input) =>{
      let res = "";
      if (input != "" && input != null){
        res = moment(input).format('DD/MM/YYYY')
      }
      return res;
    }

    dateParseYMD = (input) =>{
      let res = "";
      if (input != "" && input != null){
        res = moment(input).format('YYYY-MM-DD')
      }
      return res;
    }

    reformatOptions = (raw, label, value) => {
        return raw.map(function(data) {
          var newObj = {};
          newObj["label"] = data[label];
          newObj["value"] = data[value];
      
          return newObj;
        });
    };

    submitData = async () => {
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
              ...values,
              uuid: this.state.dataForm.cpns_uuid
            },
            confirm: true
        })
    } 

    rupiah = (num) => {
        let res = "-";
        if (num != null && num != ''){
            res = parseFloat(num).toLocaleString('id-ID', {maximumFractionDigits:2})
        }
        return res;
    }
  
    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {
        this.detailBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response

                        // load to form
                        this.setState({
                            dataForm: response,
                            birthNational: response.cpns_candidate_place_of_birth_national,
                            document: response.document_sk
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        
        this.detailBloc.fetchDetail({ uuid: this.queryParams.get('uuid') })
    }

    componentWillUnmount(){
        this.detailBloc.detailChannel.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <Card className="">
                                <CardBody>
                                    <CardTitle>Detail CPNS</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        {/* Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi. */}
                                    </CardSubtitle>
                                    <hr />

                                    
                                        <AvForm
                                            className="needs-validation"
                                            onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                        >

                                            <Row className="mb-3">
                                                <Label
                                                    className="col-md-3 col-form-label"
                                                >
                                                    Penetapan NIP BKN
                                                </Label>
                                                <Col md="3">
                                                    <AvField
                                                        name="cpns_bkn_confirmation_number"
                                                        placeholder="Nomor"
                                                        errorMessage="Masukkan Nomor"
                                                        type="text"
                                                        className="form-control"
                                                        value={this.state.dataForm?.cpns_bkn_confirmation_number}
                                                        validate={{ required: { value: true } }}
                                                        disabled={true}
                                                    />
                                                </Col>
                                                <Col md="3">
                                                    <AvField
                                                        name="cpns_bkn_confirmation_date"
                                                        placeholder="Tanggal"
                                                        errorMessage="Masukkan Tanggal"
                                                        type="date"
                                                        className="form-control"
                                                        value={this.state.dataForm?.cpns_bkn_confirmation_date}
                                                        validate={{ required: { value: true } }}
                                                        disabled={true}
                                                    />
                                                </Col>
                                            </Row>

                                            <hr />

                                            <Row className="mb-3">
                                                <Label
                                                    className="col-md-3 col-form-label"
                                                >
                                                    Nama Lengkap
                                                </Label>
                                                <Col md="4">
                                                    <AvField
                                                        name="cpns_candidate_name"
                                                        placeholder="Nama"
                                                        errorMessage="Masukkan Nama"
                                                        type="text"
                                                        className="form-control"
                                                        value={this.state.dataForm?.cpns_candidate_full_name}
                                                        validate={{ required: { value: true } }}
                                                        disabled={true}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <Label
                                                    className="col-md-3 col-form-label"
                                                >
                                                    NIP
                                                </Label>
                                                <Col md="3">
                                                    <AvField
                                                        name="cpns_candidate_nip"
                                                        placeholder="NIP"
                                                        errorMessage="Masukkan NIP"
                                                        type="text"
                                                        className="form-control"
                                                        value={this.state.dataForm?.cpns_candidate_nip}
                                                        validate={{ required: { value: true } }}
                                                        disabled={true}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <Label
                                                    className="col-md-3 col-form-label"
                                                >
                                                    Tempat Lahir
                                                </Label>
                                                <Col md="3">
                                                    <AvField
                                                        name="cpns_candidate_place_of_birth_national"
                                                        type="text"
                                                        className="form-control"
                                                        value={this.state.birthNational}
                                                        validate={{ required: { value: true } }}
                                                        disabled={true}
                                                    />
                                                </Col>
                                                <Col md="3">
                                                    <AvField
                                                        name="cpns_candidate_place_of_birth_country_name"
                                                        type="text"
                                                        className="form-control"
                                                        value={this.state.dataForm?.cpns_candidate_place_of_birth_country_name}
                                                        validate={{ required: { value: true } }}
                                                        disabled={true}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mb-3" style={ this.state.birthNational == "Dalam Negeri" ? {} : {display:'none'}}>
                                                <Label
                                                    className="col-md-3 col-form-label"
                                                >
                                                    
                                                </Label>
                                                <Col md="3">
                                                    <AvField
                                                        name="cpns_candidate_place_of_birth_province_name"
                                                        type="text"
                                                        className="form-control"
                                                        value={this.state.dataForm?.cpns_candidate_place_of_birth_province_name}
                                                        validate={{ required: { value: true } }}
                                                        disabled={true}
                                                    />
                                                </Col>
                                                <Col md="3">
                                                    <AvField
                                                        name="cpns_candidate_place_of_birth_city_name"
                                                        type="text"
                                                        className="form-control"
                                                        value={this.state.dataForm?.cpns_candidate_place_of_birth_city_name}
                                                        validate={{ required: { value: true } }}
                                                        disabled={true}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mb-3" style={ this.state.birthNational == "Dalam Negeri" ? {display:'none'} : {}}>
                                                <Label
                                                    className="col-md-3 col-form-label"
                                                >
                                                </Label>
                                                <Col md="5">
                                                    <AvField
                                                        name="cpns_candidate_place_of_birth_national"
                                                        placeholder="Kota..."
                                                        type="text"
                                                        errorMessage="Masukkan Kota"
                                                        className="form-control"
                                                        value={this.state.dataForm?.cpns_candidate_place_of_birth_city_text}
                                                        validate={{ required: { value: this.state.birthNational == "Dalam Negeri" ? false : true } }}
                                                        disabled={true}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <Label
                                                    className="col-md-3 col-form-label"
                                                >
                                                    Tanggal Lahir
                                                </Label>
                                                <Col md="3">
                                                    <AvField
                                                        name="cpns_candidate_date_of_birth"
                                                        placeholder="Tanggal Lahir"
                                                        errorMessage="Masukkan Tanggal Lahir"
                                                        type="date"
                                                        className="form-control"
                                                        value={this.state.dataForm?.cpns_candidate_date_of_birth}
                                                        validate={{ required: { value: true } }}
                                                        disabled={true}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <Label
                                                    className="col-md-3 col-form-label"
                                                >
                                                    Jenis Kelamin
                                                </Label>
                                                <Col md="3">
                                                    <AvField
                                                        name="cpns_candidate_gender_name"
                                                        type="text"
                                                        className="form-control"
                                                        value={this.state.dataForm?.cpns_candidate_gender_name}
                                                        validate={{ required: { value: true } }}
                                                        disabled={true}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <Label
                                                    className="col-md-3 col-form-label"
                                                >
                                                    Pendidikan Terakhir
                                                </Label>
                                                <Col md="3">
                                                    <AvField
                                                        name="cpns_candidate_last_education_name"
                                                        type="text"
                                                        className="form-control"
                                                        value={this.state.dataForm?.cpns_candidate_last_education_name}
                                                        validate={{ required: { value: true } }}
                                                        disabled={true}
                                                    />
                                                </Col>
                                                <Col md="3">
                                                    <AvField
                                                        name="cpns_candidate_last_education_major"
                                                        placeholder="Program Studi / Jurusan"
                                                        errorMessage="Masukkan Program Studi"
                                                        type="text"
                                                        className="form-control"
                                                        value={this.state.dataForm?.cpns_candidate_last_education_major}
                                                        validate={{ required: { value: true } }}
                                                        disabled={true}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <Label
                                                    className="col-md-3 col-form-label"
                                                >
                                                    Pangkat
                                                </Label>
                                                <Col md="3">
                                                    <AvField
                                                        name="cpns_candidate_rank_name"
                                                        type="text"
                                                        className="form-control"
                                                        value={`${this.state.dataForm?.cpns_candidate_rank_name} (${this.state.dataForm?.cpns_candidate_rank_group_room})`}
                                                        validate={{ required: { value: true } }}
                                                        disabled={true}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <Label
                                                    className="col-md-3 col-form-label"
                                                >
                                                    Jabatan
                                                </Label>
                                                <Col md="6">
                                                    <AvField
                                                        name="cpns_candidate_position_name"
                                                        type="text"
                                                        className="form-control"
                                                        value={this.state.dataForm?.cpns_candidate_position_name}
                                                        validate={{ required: { value: true } }}
                                                        disabled={true}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <Label
                                                    className="col-md-3 col-form-label"
                                                >
                                                    Unit Kerja
                                                </Label>
                                                <Col md="6">
                                                    <AvField
                                                        name="cpns_candidate_work_unit_name"
                                                        type="text"
                                                        className="form-control"
                                                        value={this.state.dataForm?.cpns_candidate_work_unit_name}
                                                        validate={{ required: { value: true } }}
                                                        disabled={true}
                                                    />
                                                </Col>
                                            </Row>

                                        <hr />

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nomor SK CPNS 
                                            </label>
                                            <Col md="3">
                                                 <AvField
                                                    name="cpns_decree_number"
                                                    id="cpns_decree_number"
                                                    placeholder="Nomor SK CPNS"
                                                    type="text"
                                                    errorMessage="Masukan Nomor SK CPNS"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    value={this.state.dataForm?.cpns_decree_number}
                                                    disabled={true}
                                                />
                                            </Col>
                                        </Row>  

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal SK CPNS 
                                            </label>
                                            <Col md="2">
                                                 <AvField
                                                    name="cpns_decree_date"
                                                    id="cpns_decree_date"
                                                    placeholder="Tanggal SK CPNS"
                                                    type="date"
                                                    errorMessage="Masukan Tanggal SK CPNS"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    value={this.dateParseYMD(this.state.dataForm?.cpns_decree_date)}
                                                    disabled={true}
                                                />
                                            </Col>
                                        </Row>    

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            TMT SK CPNS 
                                            </label>
                                            <Col md="2">
                                                 <AvField
                                                    name="cpns_decree_tmt_date"
                                                    id="cpns_decree_tmt_date"
                                                    placeholder="TMT SK CPNS"
                                                    type="date"
                                                    errorMessage="Masukan TMT SK CPNS"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    value={this.dateParseYMD(this.state.dataForm?.cpns_decree_tmt_date)}
                                                    disabled={true}
                                                />
                                            </Col>
                                        </Row>       


                                        <Row className="mb-3">
                                            <Label className="col-md-3 col-form-label">File SK CPNS</Label>
                                            <Col md="6">
                                                {
                                                    this.state.document ?
                                                        <>
                                                            {this.state.document !== null ?  
                                                                <a target={"_blank"} className="btn btn-sm btn-success" href={this.state.document?.documents_path}>
                                                                    Download <i className="fa fa-download ms-1"></i>
                                                                </a>
                                                            : '-'}
                                                        </>
                                                    :
                                                        <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>          
                                    
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to={`/kepegawaian/pns.html?index_cpns&uuid=${this.queryParams.get('period_uuid')}`}>
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to={`/kepegawaian/pns.html?index_cpns&uuid=${this.queryParams.get('period_uuid')}`}/>
                : null }
            </Fragment>
        )
    }

}

export default IndexView